export enum TechnologySolutionEnum {
  PTF_TEF_BROWSER = '312',
  APT_POS_SMART = '335',
  TFI_CONEXAO_IP = '331',
  CLOVER_KIOSK = '375',
  PAYMENT_LINK = '399',
  ECC_CARAT = '334',
  ECC_IPG = '356',
}
